import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://a6b63b25ecc17b658cf79e8f711ef1c0@o1118444.ingest.us.sentry.io/4507775017680896",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.25,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()